import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { dimensions, layers } from "@styles";

export const searchWrapper = css`
  display: flex;
  flex: 1 0 100%;
  justify-content: space-between;

  @media (min-width: ${dimensions.tablet}) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
`;

export const searchWrapperSticky = (theme: Theme) => css`
  background-color: ${theme.surface.level0};
  padding: 1rem 0;
  position: sticky;
  top: 4rem;
  z-index: ${layers.indexDrawerMax};

  @media (min-width: ${dimensions.tablet}) {
    margin-bottom: 0;
    margin-top: 0;
    top: 5rem;
    padding-top: 1rem;
  }
`;

export const hidden = css`
  display: none;
`;

export const filtersButton = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const filterIconButton = css`
  height: 2.5rem;
  width: 2.5rem;
  margin-left: 1rem;
`;

export const filterIcon = css`
  height: 1rem;
`;

export const container = {
  base: css`
    width: 100%;
  `,
};

export const searchBarButtonContainer = css`
  display: flex;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
  }
`;
